import React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import "../styles2.css";

const steps = ["Demographic Form", "Insurance Form", "Intake Form"];

export default function FormSteps({ currentStep, setCurrentStep }) {
  const [skipped, setSkipped] = React.useState(new Set());
  const navigate = useNavigate(); // Initialize useNavigate hook

  const isStepOptional = (step) => {
    return step === -1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(currentStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(currentStep);
    }

    setCurrentStep((prevStep) => prevStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setCurrentStep((prevStep) => prevStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(currentStep)) {
      throw new Error("You can't skip a step that isn't optional.");
    }

    setCurrentStep((prevStep) => prevStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(currentStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setCurrentStep(0);
  };

  // Navigate to new URL when Finish button is clicked
  const handleFinish = () => {
    navigate("/MedicalHistory"); // Replace with your desired URL
  };

  return (
    <Box className="steps_form_div">
      <Stepper activeStep={currentStep}>
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          if (isStepOptional(index)) {
            labelProps.optional = (
              <Typography variant="caption">Optional</Typography>
            );
          }
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {currentStep === steps.length ? (
        <React.Fragment>
          <Typography sx={{ mt: 2, mb: 1 }}>
            Proceed to Medical History Forms.
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
            <Box sx={{ flex: "1 1 auto" }} />
            <Button onClick={handleFinish}>Proceed</Button>{" "}
            {/* Finish button */}
          </Box>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Box
            className="preNextdiv"
            sx={{ display: "flex", flexDirection: "row", pt: 2 }}
          >
            <Button
              color="inherit"
              disabled={currentStep === 0}
              onClick={handleBack}
              sx={{ mr: 1 }}
            >
              Back
            </Button>
            <Box sx={{ flex: "1 1 auto" }} />
            {isStepOptional(currentStep) && (
              <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                Skip
              </Button>
            )}

            <Button onClick={handleNext}>
              {currentStep === steps.length - 1 ? "Finish" : "Next"}
            </Button>
          </Box>
        </React.Fragment>
      )}
    </Box>
  );
}
